import * as React from 'react';
import { useContext } from 'react';
import { ConfigContext } from 'modules/context';
import { ITranslationProps, translate } from 'components/translate-hoc';
import { TEXT_KEYS } from './own-all-items-error.constants';

import './own-all-items-error.styles.less';

const OwnAllItemsError: React.FC<ITranslationProps> = ({
    dangerouslyTranslateWithHTML: translateKey
}) => {
    const {
        config: { links: { faq: faqUrl } },
        getModeClass
    } = useContext(ConfigContext);
    return (
        <div className={getModeClass('sitegen-redeem-error-own-all-items')}>
            <div className="sitegen-redeem-error-own-all-items__content">
                <div className="sitegen-redeem-error-own-all-items__title">
                    {translateKey(TEXT_KEYS.REDEEM_ERROR_TITLE)}
                </div>
                <div className="sitegen-redeem-error-own-all-items__message">
                    {translateKey(TEXT_KEYS.REDEEM_ERROR_MESSAGE)}
                </div>
                <div className="sitegen-redeem-error-own-all-items__support">
                    {translateKey(TEXT_KEYS.REDEEM_ERROR_SUPPORT, { faqUrl })}
                </div>
            </div>
        </div>
    );
};

export default translate()(OwnAllItemsError);
